import AboutUs from "../../common/homePage/components/aboutUs";
import { Scheme } from "../json/apmc";

export const henglish = {
  //home
  "g1": "Gujarat State Agricultural Marketing,",
  "g11": "Gujarat(Gujarat Mandi)",
  "g_home": " The Gujarat State Agricultural Marketing Board (Gujarat Mandi Board, GSAMB) was established to regulate and manage the buying, selling, and storage of agricultural produce. It ensures fair trade practices for farmers, traders, and buyers. GSAMB oversees the marketing of agricultural, horticultural, animal husbandry, and forestry products to maintain a smooth supply chain. It operates as an independent body with the power to own and manage properties.",
  "q_link": "Quick Links",
  "trader_reg": "Trader Registration",
  "panel_reg": " Panel Engineer Registration",
  "gca_reg": "General Commission agent Registration",
  "tra_desc": "Apply for registration to obtain a valid APMC trading license.",
  "panel_desc": "Register to become an authorized Panel Engineer for APMC services.",
  "gca_desc": "Apply for registration to obtain a valid GCA trading license.",
  "g2": "DIRECTOR OF AGRICULTURE MARKETING AND RURAL FINANCE",
  "directorInfo":"Director of Marketing & Rural Finance",
  "directorParaInfo":"The Gujarat State Agricultural Marketing Board (Gujarat Mandi Board, GSAMB) was established to regulate & manage the buying, selling, and storage of agricultural produce. It ensures fair trade practices for farmers, traders, & buyers. GSAMB oversees the marketing of agricultural, horticultural, animal husbandry, & forestry products to maintain a smooth supply chain. It operates as an independent body with the power to own & manage properties.",
  "logout": "Logout",
  "lang": "Language",
  "main": "Main",
  "home": "Home",
  "quick_links": "Quick Links",
  "get_touch": "Get in Touch",
  "totAPMCs": "Total APMCs",
  "totComm": "Total Commodities",
  "totDist": "Total Districts",
  "totTal": "Total Talukas",
  "gallery": "Gallery",
  "terms_conditions": "Terms & Conditions",
  "privacy_policy": "Privacy Policy",
  "scheme_forms": "Schemes and Forms",
  "scheme_desc": "Apply for government schemes & other application forms.",
  "announcement": "Announcement",
  "readMore": "Read More",
  "contactAddress": "Block No.13, 2nd floor, Dr. Jivraj Mehta Bhavan, Gandhinagar.",
  "tra_login": "Trader Login",
  "gc_login": "GCA Login",
  "spon_login": "Sponsor Login",
  "pa_login": "Panel Engineer Login",
  "dr_login": "District Registrar Login",
  "ap_login": "APMC Login",
  "ho_login": "Head Officer Login",
  "about": "About Us",
  "contact": "Contact Us",
  "market": "Market Rate",
  "Scheme": "Scheme",
  "doa": "Department of Agriculture",
  "goi": "Government of Gujarat",
  "empower": "Empowering Farmers Through Fair Trade",
  "sub_empower": "Connecting farmers to markets, ensuring transparency, and promoting sustainable agriculture practices.",
  "reg_as_trader": "Register as Trader",
  "view_market_rate": "View Market Rates",

  "AboutUs": 'About Department',
  "ourGallery": 'Our Gallery',
  "introduction": 'Introduction',
  "aboutIntro1": 'There are a total of 406 mandi markets in the State of Gujarat with 214 main yards and 192 sub-yards located at taluka headquarters and other major trading places. At these places, the sale of veal farm produce and are regulated under the Gujarat Farm Market Act 1963, Farm Produce Market Committees have been constituted for its management. Generally each taluka headquarters has a declared main organization for purchase and sale of farm produce and a market committee is constituted at that place. So that the farmers can bring their goods directly to the market and sell them through auctions and get their produce at reasonable prices and fair value.',
  
  "aboutIntro2": 'Year 2023-24 i.e. as on 31-3-2024, a total of 224 market committees have been formed in the state of Gujarat. And the entire area of the state is covered under Market Act.',
  "aboutIntro3": 'A total of 51 market committees have been formed in the tribal areas of the State. It has 45 main yards and 73 sub yards, totalling 118 mandi markets. In addition, there are 129 "haat markets" in tribal areas.',

  "aboutIntro4":"Constitution of Market Committee",
  "aboutIntro5":"Under Section-11 of the Market Act, each market committee will consist of the following members.",
  "aboutIntro6":"Ten farmer members",
  "aboutIntro7":"Four trading members",
  "aboutIntro8":"One representative if the number of co-operative buying and selling societies situated in the market area and holding general license is not more than two, two representatives if more than two",
  "aboutIntro9":"An appointed member of the local authority where the main market square is located",
  "aboutIntro10":"Two appointed members of the Government.",
  "aboutIntro11":"In this regard (1) Ten farmers who have been elected by the members of the Management Committees of the Co-operative Societies providing agriculture credit in the market area. (2) General licensed traders elect four members from among themselves.",

  "missionAndVision":"Mission and Vision",
  "missionAndVisionDesc":"Vision and mission of progress in Agriculture and Market Sector in next 5 years",

  "missVis1":"207 market committees are functioning in 226 talukas in the State. In which, 199 main wards and 191 sub-yards, there are a total of 400 markets. For the last five years, the State Government has received Rs.111.08 crores from various schemes, in addition to infrastructural facilities, modern facilities are being built in these market committees, today the agricultural production in these market committees has increased three times and more and more farmers are using the yards of the market committees, due to which they are getting good and reasonable prices.",

  "missVis2":"In order to keep pace with the upcoming changes in the market sector and in commensurate with the competitive situation created due to the development and globalization of the market sector, the State Government amended the Agricultural Produce Market Act in the year 2007 to include private market, e-market, farmer consumer market, common license, contract farming, special market, important provisions have been made and due to this, many changes in the market sector have directly benefited the farmers of the State. However, the market still has a lot to do, which is going to be done in the next five years.",

    "missVis3":"All the market committees of the State of Gujarat shall be able to grade, sort and value add all their major and minor agricultural produce and sell them.",

    "missVis4":"Establishment of mall/retail outlet managed by Market Committee at Market Committee’s level.",

    "missVis5":"“Market system for Organic Farming and Natural Farming”",

    "missVis6":"In the current times, due to the use of chemical fertilizers and pesticides, the quality of food items is decreasing, the lack of nutrients in the body, various types of communicable diseases like BP, diabetes, cholesterol, arthritis, osteoporosis, stress, depression, anemia have taken over and The World Health Organization is concerned about these diseases. In such circumstances, the inclination towards clean and sattvic i.e. balanced and complete diet has increased, and due to this, today the progressive farmers of the State are turning towards organic farming and while there is a big revolution in the field of organic farming, the produce from this farming also provides a healthy market for the farm produce.",

    "missVis7":"That kind of planning has been done by the Government, in which the State Market Committees have decided to give priority to the sales system for this, in which the state government is concerned with the coordination of producer farmers, buyers, traders and consumers at the level of an organized market committee, and efforts are underway to set up such a system in the near future to directly benefit the farmers and traders.",

    "missVis8":"Establishment of Farmers’ Mall",
    "missVis9":"When farmers take their farm produce and come to the market committees for sale, the money that comes into their hands after sale, they have to go to other markets to buy their life necessities and farm useful things. Many a times the farmers have to come back to buy what they do not get the next day at this time. The State Government is also thinking of setting up a “Mall” in the main yard of the Market Committee keeping in mind that the farmer can see all the necessities of life such as implements, fertilizers, seeds, pesticides, etc. Planning is planned in the next five years to create an environment where farmers can sell their produce, observe and buy on a “no profit-no loss” basis, and 50% of the State’s Market Committee, is the name of the State Government.",

  "glimplseOfAchi": 'Glimpse of all the achievements and the work done by the Gujarat government.',

  "about_since_year": "SINCE 1963",
  "about_market_commitee": "The Agricultural produce Market Committee",
  "about_us_content_1": `The Agricultural Produce Market Committee (APMC) has been a foundational pillar of Gujarat's agricultural 
                        economy. Our core mission is to safeguard the interests of our farmers by creating a fair, transparent, 
                        and competitive trading environment. We are dedicated to an organized marketing system that ensures every 
                        farmer receives the true value for their hard work.`,
  "about_us_content_2": `APMC Gujarat manages a statewide network of modern market yards that serve as critical hubs of economic 
                        activity. We provide essential infrastructure—including scientific storage, electronic weighing systems, 
                        and auction platforms. By licensing and regulating all market functionaries, including traders and agents,
                         we ensure every transaction is transparent and ethical, building unshakable trust within the supply chain.`,
  "about_us_content_3": `As we look to the future, we are committed to empowering our farmers through innovation, especially via the 
                        e-NAM (Electronic National Agriculture Market) platform.`,

  "minister_header1": 'Key Government Officials',
  "minister_header2": 'Meet the dedicated leaders driving agricultural market development across Gujarat',                        

  "minister_Bhupendra": "Shri Bhupendra Patel",
  "minister_Bhupendra_details1": `Hon'ble Chief Minister`,
  "minister_Bhupendra_details2": `Government of Gujarat`,

  "minister_Rameshbhai": "Shri Rameshbhai Bhurabhai Katara",
  "minister_Rameshbhai_details1": `Hon’ble Minister of State Agriculture & Farmers Welfare,`,
  "minister_Rameshbhai_details2": `Cooperation, Animal Husbandry and Cow Breeding`,

  "minister_Jitubhai": "Shri Jitubhai Vaghani",
  "minister_Jitubhai_details1": `Hon'ble Minister of Agriculture & Farmers Welfare,`,
  "minister_Jitubhai_details2": `Cooperation, Animal Husbandry, Cow Breeding, Fisheries`,

  "minister_Arunkumar": "Shri Arunkumar M Solanki ,IAS",
  "minister_Arunkumar_details1": `Managing Director Gujarat State Warehousing`,
  "minister_Arunkumar_details2": ` Corporation`,

  "minister_Pandya": "Shri M.P. Pandya, IAS",
  "minister_Pandya_details1": `Registrar, Co-operative Societies,`,
  "minister_Pandya_details2": `Government of Gujarat`,

  "minister_Patel": 'Shri H.R.Patel',
  "minister_Patel_details1": `Director of Agriculture Marketing`,
  "minister_Patel_details2": `& Rural Finance`,

  "g_map_1": 'Administrative Map of',
  "g_map_2": 'APMC Coverage in',
  "g_map_3": 'Gujarat',
  "g_map_4": 'Explore 145+ agricultural markets across 33',
  "g_map_5": 'districts of Gujarat.',

  "pdf_page_headers1": 'Acts, Rules & Amendments',
  "pdf_page_headers2": 'Access official government documents governing agricultural markets in Gujarat',
  "pdf_page_Act_1963": 'The Gujarat Agriculture Produce Market Act 1963',
  "pdf_page_Act_1963_content": 'The Gujarat Agricultural Produce Markets Act, 1963 (As modified up to the 30th June 2006)',
  "pdf_page_Legal_Amendments": 'Legal Amendments',
  "pdf_page_Legal_Amendments_content1": 'The Gujarat Agricultural ProduceMarkets (Amendment) Act, 2015',
  "pdf_page_Legal_Amendments_content2": 'The Gujarat Agricultural ProduceMarkets (Second Amendment) Act, 2015',
  "pdf_page_Legal_Amendments_content3": 'The Gujarat Agriculture Produce Makets (Amendment) Act 2020',
  "pdf_page_Legal_Amendments_content4": 'The Gujarat Agriculture Produce Makets (Amendment) Act 2023',
  "pdf_page_APMC_Rules": 'APMC Rules',
  "pdf_page_APMC_Rules_content1" : 'The Gujarat Co-operative Societies Rules 1965( As modified upto 30th September 1991)',
  "pdf_page_General_Circulars" : 'General Circulars',
  "pdf_page_General_Circulars_content1" : 'Daan circular',
  "pdf_page_General_Circulars_content2" : 'Secretory extension',
  "pdf_page_General_Circulars_content3" : 'Circular checklist (Last updated: 18/06/2025 )',
  "pdf_page_General_Circulars_content4" : 'Kadda pratha circular - I',
  "pdf_page_General_Circulars_content5" : 'Kadda pratha circular - II',
  "pdf_page_General_Circulars_content6" : 'Circular of the Scheme',
  "pdf_page_General_Circulars_content7" : 'APMC Audit Circular',
  "pdf_page_General_Circulars_content8" : 'Vargikaran paripatr-circular',
  "view_pdf": 'View PDF',

  "slider1A": "Digital Transformation in Agriculture",
  "slider1B": "Embracing technology to create transparent and efficient agricultural markets across India",
  "slider2A": "Empowering Farmers with Fair Prices",
  "slider2B": "Transparent pricing mechanism ensuring farmers get the best value for their produce",
  "slider3A": "Modern Infrastructure for Better Trade",
  "slider3B": "State-of-the-art market yards with advanced facilities for trading and storage",
  "slider4A": "Quality Assurance & Standards",
  "slider4B": "Certified testing laboratories ensuring quality produce reaches consumers",
  "register_now": "Register Now",
  "know_more": "Know More",
  "trader": "Trader",
  "panel_engineer": "Panel Engineer",
  "gca": "General Commission Agent",
  "docs_required_title": "Documents Required for Registration",
  "docs_required_subtitle": "Documents Required for Registration",
  "note_label": "Note:",
  "note_text": "One document from each section is required.",
  "doc_identity": "Proof of Identity: ",
  "doc_identity_options": "Aadhaar Card / Driving License / Passport / Voter ID / PAN Card",
  "doc_address": "Proof of Address: ",
  "doc_address_options": "Aadhaar / Driving License / Passport / Voter ID / PAN Card / Domicile / Electricity Bill",
  "doc_dob": "Proof of Date of Birth: ",
  "doc_dob_options": "Passport / Voter ID / PAN Card / Birth Certificate / 10th Marksheet",
  "close_button": "Close",
  "proceed_button": "Proceed",
  "profiles":"Profiles",
}